// Fade-up scroll animation
// Add data-fade-up to any element to opt in.
// Add data-fade-delay="300" (ms) to delay the trigger (useful for staggering
// sibling items — increment the delay on each child in the template).

const fadeUpEls = document.querySelectorAll('[data-fade-up]');

if (fadeUpEls.length) {
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var delay = parseInt(el.dataset.fadeDelay, 10) || 0;
            setTimeout(function () {
                el.classList.add('fade-up-visible');
            }, delay);
            observer.unobserve(el);
        });
    }, { threshold: 0.12 });

    fadeUpEls.forEach(function (el) {
        observer.observe(el);
    });
}
